import React from 'react';
import PropTypes from 'prop-types';
export default function TableBody(_ref) {
  var children = _ref.children;
  return React.createElement("tbody", null, children);
}
TableBody.propTypes = {
  children: PropTypes.node
};
TableBody.contextTypes = {
  styles: PropTypes.object,
  store: PropTypes.object
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/spectacle/es/components/table-body.js
// module id = 382
// module chunks = 0